import { Select, MenuItem, TextField, InputLabel} from '@mui/material'
import React, { useEffect, useState} from 'react'
import {useNotify, useTranslate} from 'react-admin'
import { currencyServices } from 'src/services/payment/currency/currency.service'
import LoadingButton from '@mui/lab/LoadingButton'
import { paymentServices } from 'src/services/payment/Payment.service'
import { ErrorHandler } from 'src/helper/ErrorHandler'

export const ReturnForm = ({record, hash_reservation, setOpenReturnDialog}) => {
    const translate = useTranslate()
    const notify = useNotify()
    const [currencyList, setCurrencyList] = useState([])
    const [isSaveLoading, seIsSaveLoading] = useState(false)
    const [tmaError, setTmaError] = useState(null)
    const getCurrency = () =>{
        currencyServices.getByAll().then((res)=>{
            setCurrencyList(res)
            const currency_id = res
                .find(currency=>currency.short_name == record?.currency_unused).id
            setForm({...form, currency_id})
        })
    }
    const [form, setForm] = useState({
        currency_id:'',
        amount:'',
        hash_reservation
    })

    useEffect(()=>{
        getCurrency()
    },[])

    const onSave = () =>{
        if(Number(form.amount) > record?.amount_unused){
            notify('ra.message.amount_exceeds_unused', {
                messageArgs:{amount_credit:record?.amount_unused},
                type: 'error',
            })
        } else if(Number(form.amount) === 0){
            notify('ra.validation.minValue', {
                messageArgs:{min:0},
                type: 'error',
            })
        } else {
            form.amount = Number(form.amount)
            seIsSaveLoading(true)
            paymentServices.returnCredits(form).then(()=>{
                setOpenReturnDialog(false)
                notify('ra.message.return_success', {
                    type: 'success',
                })

            }).catch((err)=>{
                if(err?.response?.status || err?.status_code){
                    setTmaError(err)
                } else {
                    notify('ra.message.return_error', {
                        type: 'error',
                    })
                }   
            }).finally(()=>{
                seIsSaveLoading(false)
            })
        }
    }
  return (
    <div>
        <div style={{display:'flex', flexDirection:'row'}}>
            <div style={{width:'100%', marginRight:'5px'}}>
                <InputLabel id="currency_id">{translate('ra.entity.currency')}</InputLabel>
                <Select
                    required
                    id="currency_id"
                    fullWidth
                    size='small'
                    onChange={(value)=>{setForm({...form, currency_id:value.target.value})}}
                    value={form.currency_id}
                    renderValue={value=> value ? currencyList.find(currency => currency.id === value)?.short_name : ''}
                >
                    {
                        currencyList.map(currency=>(
                            <MenuItem key={currency.id} value={currency.id}>
                                {currency.short_name}
                            </MenuItem>
                        ))
                    }
                </Select>
            </div>
            <div style={{width:'100%'}}>
                <InputLabel id="amount">{translate('ra.field.total_to_return')}</InputLabel>
                <TextField
                    type='number'
                    id='amount'
                    value={form.amount}
                    required
                    onChange={(value)=>{setForm({...form, amount:value.target.value})}}
                    fullWidth
                    size='small'
                />
            </div>
        </div>
        <LoadingButton loading={isSaveLoading} onClick={onSave} style={{marginTop:'30px'}} variant='contained'>
            {
                translate('ra.action.save')
            }
        </LoadingButton>
        {tmaError && <ErrorHandler error={tmaError} callback={''}/>}
    </div>
  )
}
